import styled, { css } from 'styled-components';
import { ColProps } from './col.interface';

const Col = styled.div<ColProps>`
  ${({ justify, align }) => css`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: ${justify};
    align-items: ${align};
  `}
`;

Col.defaultProps = {
  align: 'stretch',
  justify: 'flex-start',
};

export default Col;
